function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.86 18.58c-.5.1-2.03.42-2.26.42-.88 0-1.6-.67-1.6-1.5 0-.67.47-1.24 1.1-1.43-.06-.18-.1-.37-.1-.57 0-.83.67-1.5 1.5-1.5.2 0 .38.04.55.1a1.506 1.506 0 012.9 0c.17-.06.35-.1.55-.1.83 0 1.5.67 1.5 1.5 0 .2-.04.4-.1.57.63.2 1.1.76 1.1 1.43 0 .83-.7 1.5-1.6 1.5-.22 0-1.77-.32-2.26-.43L8.5 20h-2l.36-1.42zm9-3c-.5.1-2.03.42-2.26.42-.88 0-1.6-.67-1.6-1.5 0-.67.47-1.24 1.1-1.43-.06-.18-.1-.37-.1-.57 0-.83.67-1.5 1.5-1.5.2 0 .38.04.55.1a1.506 1.506 0 012.9 0c.17-.06.35-.1.55-.1.83 0 1.5.67 1.5 1.5 0 .2-.04.4-.1.57.63.2 1.1.76 1.1 1.43 0 .83-.7 1.5-1.6 1.5-.22 0-1.77-.32-2.26-.43L17.5 17h-2l.36-1.42zm-6-6c-.5.1-2.03.42-2.26.42C6.72 10 6 9.33 6 8.5c0-.67.47-1.24 1.1-1.43C7.05 6.9 7 6.7 7 6.5 7 5.67 7.67 5 8.5 5c.2 0 .38.04.55.1a1.506 1.506 0 012.9 0c.17-.06.35-.1.55-.1.83 0 1.5.67 1.5 1.5 0 .2-.04.4-.1.57.63.2 1.1.76 1.1 1.43 0 .83-.7 1.5-1.6 1.5-.22 0-1.77-.32-2.26-.43L11.5 11h-2l.36-1.42z",
  fill: "currentColor",
  fillRule: "evenodd"
});

var SvgLocationHeath = function SvgLocationHeath(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
};

export default SvgLocationHeath;